import React, {useState} from 'react';

const Constantes = {
	stepZoom: 0.2,
	maxZoom: 1.8,
	minZoom: 0.2,
}

function Zoom(props) {
	let [disabledBtn, setDisabledBtn] = useState({
		zoomIn: false,
		zoomOut: false
	});

	let {
		currentZoom,
		setCurrentZoom,
		active
	} = props;

	const checkZoom = (value) => {
		let temp = {...disabledBtn};
		temp.zoomIn = value >= Constantes.maxZoom;
		temp.zoomOut = value <= Constantes.minZoom;
		setDisabledBtn(temp);
		//TODO CHECK
		//props.updateMoveGroup();
	}

	const updateZoom = (sens) => {
		let temp = parseFloat(currentZoom);
		if (sens === 'up') {
			temp += Constantes.stepZoom;
			if (temp > Constantes.maxZoom) {
				temp = Constantes.maxZoom;
			}
		}
		if (sens === 'down') {
			temp -= Constantes.stepZoom;
			if (temp < Constantes.minZoom) {
				temp = Constantes.minZoom;
			}
		}
		temp = Math.round(temp * 100) / 100;

		setCurrentZoom(temp);
		checkZoom(temp);
	}

	return (
		<>
			<button
				type="button"
				className={'btn btntool btn-primary p-0' + ((disabledBtn.zoomIn || active === false) ? ' disabled' : '')}
				onClick={() => {
					updateZoom('up');
				}}
			>
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
					<circle cx="11" cy="11" r="8"></circle>
					<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
					<line x1="11" y1="8" x2="11" y2="14"></line>
					<line x1="8" y1="11" x2="14" y2="11"></line>
				</svg>
			</button>

			<button
				type="button"
				className={'btn btntool btn-primary p-0' + ((disabledBtn.zoomOut || active === false) ? ' disabled' : '')}
				onClick={() => {
					updateZoom('down');
				}}
			>
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
					<circle cx="11" cy="11" r="8"></circle>
					<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
					<line x1="8" y1="11" x2="14" y2="11"></line>
				</svg>
			</button>
		</>
	);
}

export default Zoom;
